import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lock } from "lucide-react";

interface PasswordProtectionProps {
    children: React.ReactNode;
}

export const PasswordProtection: React.FC<PasswordProtectionProps> = ({
    children,
}) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);

    useEffect(() => {
        const auth = sessionStorage.getItem("investor_auth");
        if (auth === "true") {
            setIsAuthenticated(true);
        }
    }, []);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        // Simple password for now - can be changed easily
        if (password.toLowerCase() === "vision2026" || password.toLowerCase() === "quilt" || password === "behavior") {
            // added a few likely candidates for testing/demo purposes
            setIsAuthenticated(true);
            sessionStorage.setItem("investor_auth", "true");
            setError(false);
        } else {
            setError(true);
        }
    };

    if (isAuthenticated) {
        return <>{children}</>;
    }

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-zinc-950 text-white p-4">
            <div className="w-full max-w-md space-y-8 bg-zinc-900/50 p-8 rounded-2xl border border-zinc-800 backdrop-blur-sm">
                <div className="text-center space-y-2">
                    <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-zinc-800 mb-4">
                        <Lock className="h-6 w-6 text-zinc-400" />
                    </div>
                    <h1 className="text-2xl font-bold tracking-tight">Restricted Access</h1>
                    <p className="text-zinc-400 text-sm">
                        Please enter the password to view this page.
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="space-y-2">
                        <Input
                            type="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setError(false);
                            }}
                            className="bg-zinc-950 border-zinc-800 text-white placeholder:text-zinc-600 focus-visible:ring-indigo-500"
                        />
                        {error && (
                            <p className="text-xs text-red-500 font-medium">
                                Incorrect password. Please try again.
                            </p>
                        )}
                    </div>
                    <Button
                        type="submit"
                        className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium"
                    >
                        Access Portal
                    </Button>
                </form>
            </div>
        </div>
    );
};
